/**
 * @file     EstimateFocusButton.tsx
 * @purpose  A call to action lower on the front door that points at the
 *           estimate form: it scrolls to the form and focuses its address
 *           field instead of opening anything new.
 */
'use client';

import type { ReactNode } from 'react';
import { OWNER_LISTING_EVENTS, useOwnerListingAnalytics } from '../analytics';
import { OwnerButton } from '../ui';
import { ESTIMATE_ADDRESS_INPUT_ID } from './RentEstimateCard';

export function EstimateFocusButton({ children }: { children: ReactNode }) {
  const { track } = useOwnerListingAnalytics();
  return (
    <OwnerButton
      href="#rent-estimate"
      onClick={(e) => {
        e.preventDefault();
        track(OWNER_LISTING_EVENTS.ownerEntryClick, { surface: 'landing' });
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        document.getElementById('rent-estimate')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        window.setTimeout(() => document.getElementById(ESTIMATE_ADDRESS_INPUT_ID)?.focus({ preventScroll: true }), reduce ? 0 : 300);
      }}
    >
      {children}
    </OwnerButton>
  );
}
